import {
    Wrapper,
    Header,
    Intro, Advantages, FormSection
} from "./ctiAndDarkiForce.Elements";
import {SiteColors} from '../../config/site-colors';
import 'react-bootstrap/';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useRef, useState} from "react";
import {Helmet} from "react-helmet";
import 'bootstrap/dist/css/bootstrap.min.css';
import {useNavigate} from "react-router-dom";
import {CornMobile, ScrollTop} from "../home/HomeElements";
import scrollTopIcon from "../../assets/images/ScrolltoTopIcon.png";
import {Input} from "@mui/material";
import agent from "../../utils";
import {toast} from "react-toastify";
import {Link} from 'react-router-dom';
import parse from 'html-react-parser';
//assets
import ImgHeader from '../../assets/images/cti-darki-force/cti-header.png';
import ImgBrain from '../../assets/images/cti-darki-force/cti-brain.png';
import Img4 from '../../assets/images/cti-darki-force/cti-img-4.png';
import ImgDarkWeb from '../../assets/images/cti-darki-force/darkweb.png';
import ImgDashboardDarkMode from '../../assets/images/cti-darki-force/Dashboard_Dark_Mode.png';
import ImgDashboardDarkModeOverlapped from '../../assets/images/cti-darki-force/Dashboard_Dark_Mode_Overlapped.png';
import ImgGermanLang from '../../assets/images/cti-darki-force/german_language.png';
import ImgRiskModification from '../../assets/images/cti-darki-force/Risk_Modification.png';
import ImgRiskModificationOverlapped from '../../assets/images/cti-darki-force/Risk_Modification_Overlapped.png';
import ImgSocialMedia from '../../assets/images/cti-darki-force/social_media.png';
import ImgTakedownFB from '../../assets/images/cti-darki-force/takedown_facebook.png';
import ImgTakedownHighRisks from '../../assets/images/cti-darki-force/Takedown_high_Risks.png';
import ImgTicketNotes from '../../assets/images/cti-darki-force/Ticket_notes1.png';
import ImgTTI from '../../assets/images/cti-darki-force/TTI.png';

import BlockCone from "../../components/BlockCone";
import {FieldRow, FormRow} from "../contactUs/ContactUsElement";
import {SpanPolicy} from "../../components/EmailForm/EmailFormElements";
import {DarkAgentMeetForm} from "../theDarkAgent/theDarkAgent.Elements";
import {isValidEmail} from '../../helpers/email-helper';
import CaptchaDialog from "../../common/captchaDialoge";
import ThanksDialog from "../../common/thanksDialog";
import {MESSAGES} from "../../constants/messages";
import {scrollToSelector} from "../../helpers/dom-helper";

const CTIAndDarkiForce = ({isScrolled, setReshowDialog}) => {
    const [playVideo, setPlayVideo] = useState(false);
    const targetSection = useSelector((state) => state.scroll.targetSection);
    const navigate = useNavigate();

    const [email, setEmail] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [messageValidation, setMessageValidation] = useState(false);
    const fieldsStyle = {flex: '1 1 auto', marginTop: '3vh'};
    const sxProps = {
        '& label.Mui-focused': {
            color: 'black',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#002F87',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#002F87',
            },
            '&:hover fieldset': {
                borderColor: '#002F87',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#002F87',
            }
        },
        '& .MuiInputBase-input': {
            width: '100%',
            fontSize: '15px'
        }
    };

    //captcha
    const [loading, setLoading] = useState(false);
    const [captchaKey, setCaptchaKey] = useState(null);
    const [captchaOpen, setCaptchaOpen] = useState(false);
    const [thanksOpen, setThanksOpen] = useState(false);
    const invalidEmailMessage = "Email is not valid";

    useEffect(() => {
        if (targetSection === null) {
            window.scrollTo(0, 0);
        }
        scrollToSelector(window.location.hash);
    }, [])


    const handleSubmit = () => {
        if (localStorage.getItem('cookie') !== '1')
            setReshowDialog(true);
        else {
            if (isValidEmail(email)) {
                setCaptchaOpen(true);
            } else {
                setMessageValidation(invalidEmailMessage);
            }
        }
    }
    const submitDemo = () => {
        if (isValidEmail(email)) {
            setIsLoading(true);
            agent.CTIDarkiForceDemos.postEmail({
                "email": email,
                "g-recaptcha-response": captchaKey
            }).then(() => {
                setEmail("");
                setCaptchaOpen(false);
                toast.success(<>{parse(MESSAGES.SUCCESS.DEMO_FORM_SUBMITTED)}</>);
            }).catch(() => {
                toast.error("An error occurred")
            }).finally(() => {
                setIsLoading(false);
                setMessageValidation(null);
            })
        } else {
            setMessageValidation("Email is not valid");
        }
    }

    return <>
        <Helmet>
            <title>CTI & DarkiForce</title>
            <meta name="robots" content="nofollow"></meta>
            <meta name="description"
                  content="Your Ultimate Digital Risk and Threat Intel Ally"/>
        </Helmet>
        <Wrapper>
            <Header.Container style={{backgroundImage: `url(${ImgHeader})`}}>
                <Container fluid>
                    <Header.Meta>
                        <p>Actionable Intelligence.<br/> Unmatched Visibility</p>
                        <h1><Link to={'/darkivore'}>Darkivore</Link> Delivers.</h1>
                    </Header.Meta>
                </Container>
            </Header.Container>
            <Intro.Container>
                <BlockCone zIndex={0} startColor={'#ebebeb'} stopColor={'#e1e1e1'}/>
                <Container fluid>
                    <Row>
                        <Col md={4} className={'img-holder'}>
                            <img alt="" src={ImgBrain} alt="" className={"img-fluid"}/>
                        </Col>
                        <Col md={8} className={'d-flex align-items-start justify-content-center flex-column'}>
                            <h1>Cyber Threat Intelligence & DarkiForce</h1>
                            <p className={'d-block'}>
                                Darkivore delivers real-time, high-fidelity cyber threat intelligence by combining
                                automated
                                threat collection with the expertise of DarkiForce, our elite threat intelligence team.
                                In
                                addition to our Darkibot network, Darkivore is enriched with 50+ commercial,
                                open-source,
                                and CSIRT feeds, Darkivore ingests thousands of IoCs per hour to provide deep,
                                multilingual,
                                and actionable insights.<br/>
                                From dark web visibility and SOCMINT to seamless API integrations and rapid takedowns,
                                Darkivore turns threat data into decisive action: Powered by machines. Guided by
                                experts.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Intro.Container>
            <Advantages.Container>
                <Container fluid className={'d-flex flex-column'}>
                    <h1>Core Advantages</h1>
                    <Row id={'csirt-threat-feeds'}>
                        <Col lg={7} className={'add-space-on-mobile'}>
                            <Advantages.ContentBlock className={'mb-lg-5'}>
                                <h2>Darkivore Feeds Augmented with 50+ Commercial, Opensource, and CSIRT Threat
                                    Feeds</h2>
                                <p>
                                    Darkivore ingests thousands of indicators of compromise (IoCs), including IP
                                    addresses,
                                    URLs, domains, and file hashes, every hour. By integrating proprietary intelligence
                                    with
                                    data from over 50 trusted commercial, open-source, and CSIRT feeds, it delivers
                                    broad,
                                    real-time threat coverage. Because no one source has it all.<br/><br/>
                                    The Darkivore platform provides curated, high-fidelity threat intelligence designed
                                    for
                                    immediate operational use. For organizations requiring broader feed integration, a
                                    MISP
                                    mirror is also available.
                                </p>
                            </Advantages.ContentBlock>
                            <img alt="" src={ImgTTI} className={'img-overlapping d-none d-lg-block'}/>
                        </Col>
                        <Col md={5} className={'d-none d-lg-block'}>
                            <img alt="" src={ImgDashboardDarkMode} className={'img-fluid'}/>
                        </Col>
                        <Col md={12} className={'d-lg-none'}>
                            <img alt="" src={ImgDashboardDarkModeOverlapped} className={'img-fluid'}/>
                        </Col>
                    </Row>
                    <hr/>
                    <Row id={'api-integration-for-security-orchestration'}>
                        <Advantages.ContentBlock>
                            <h2>Seamless API Integration for Security Orchestration</h2>
                            <p>
                                Darkivore delivers centralized, enriched threat intelligence feeds ready for seamless
                                integration with your security tools. It streamlines threat visibility through easy
                                dispatch, ingestion, and enrichment in SIEMs and other platforms. Simply provide your
                                feed
                                lists, integration points, and API credentials; Darkivore handles the rest. Our CTI
                                solution
                                powers tactical intelligence, seamless feed sharing, and consistent monthly
                                updates.<br/><br/>
                                Darkivore integrates effortlessly into your security stack via a robust REST API,
                                supporting standards like MISP connectors and STIX/TAXII for machine-to-machine data
                                exchange.<br/><br/>
                                It pushes intelligence into SIEMs, XDR/EDR, web and email filters, and SOAR platforms,
                                with
                                support for pull/push integrations with tools like <b>QRadar, LogRhythm, Securonix,
                                Trend
                                Micro, and FortiSIEM.</b><br/><br/>
                                Its customizable crawlers can push relevant alerts if API pull is not available,
                                reducing
                                time-to-action by up to 95%.
                            </p>
                        </Advantages.ContentBlock>
                    </Row>
                    <hr/>
                    <Row id={'threat-detection-global-intelligence-collection'}>
                        <Col md={6} className={'add-space-on-mobile'}>
                            <Advantages.ContentBlock>
                                <h2>Multilingual Threat Detection and Global Intelligence Collection</h2>
                                <p>
                                    Darkivore detects threats across 120+ scripts and languages, powered by its Dark
                                    Agent
                                    technology. It enriches IoCs with attribution, geolocation, and domain registration
                                    data,
                                    right out of the box. Backed by a global footprint in 50+ countries, it collects
                                    proprietary
                                    intelligence on diverse threat actors and TTPs. As part of the Potech Group,
                                    Darkivore
                                    benefits from Nigma’s physical and geo-intelligence, and multiple strategic
                                    alliances
                                    for
                                    predictive threat analysis.
                                </p>
                            </Advantages.ContentBlock>
                        </Col>
                        <Col md={6}>
                            <img alt="" src={ImgGermanLang} className={'img-fluid'}/>
                        </Col>
                    </Row>
                    <hr/>
                    <Row id={'granular-deep-dw-visibility'}>
                        <Col md={6} className={'add-space-on-mobile'}>
                            <Advantages.ContentBlock>
                                <h2>Granular Deep and Dark Web Visibility</h2>
                                <p>
                                    From low-risk leaks to high-risk threats, Darkivore provides sharp, noise-free
                                    visibility across the Deep and Dark Web. Its engine and Darkiforce team crawl hidden
                                    forums and marketplaces to surface the most relevant IoCs and threat signals. You
                                    can
                                    tailor searches, request investigations, or rely on recurring analyst support.
                                    Backed by
                                    IEEE-cited research, Darkivore cuts through fear and hype to deliver clear and
                                    actionable intelligence.
                                </p>
                            </Advantages.ContentBlock>
                        </Col>
                        <Col md={6}>
                            <img alt="" src={ImgDarkWeb} className={'img-fluid'}/>
                        </Col>
                    </Row>
                    <hr/>
                    <Row id={'machine-learning'}>
                        <Col lg={6}>
                            <Advantages.ContentBlock>
                                <h2>Machine Learning, Agentic and Analyst Curated Results</h2>
                                <p>
                                    Darkivore leverages machine learning, agentic capabilities and expert analyst
                                    curation, to
                                    deliver actionable alerts and optimize efforts by cutting false positives up to 90%.
                                    Our smart
                                    engine learns and adapts, fine-tuning its sensitivity based on behavior, time
                                    patterns, and your
                                    direct input. Our intuitive portal offers rich dashboards, customizable alerts, and
                                    powerful deep
                                    search functionalities, putting you in command. Benefit from regular executive
                                    reports and
                                    monthly success sessions designed to keep our insights aligned with your changing
                                    security
                                    landscape.
                                </p>
                            </Advantages.ContentBlock>
                        </Col>
                        <Col md={6} className={'d-none d-lg-block'}>
                            <img alt="" src={Img4} className={'img-fluid'}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6} className={'d-none d-lg-block add-space-on-mobile'}>
                            <img alt="" src={ImgTicketNotes} className={'img-fluid'}/>
                        </Col>
                        <Col sm={6} className={'d-none d-lg-block'}>
                            <img alt="" src={ImgRiskModification} className={'img-fluid'}/>
                        </Col>
                        <Col md={12} className={'d-lg-none'}>
                            <img alt="" src={ImgRiskModificationOverlapped} className={'img-fluid'}/>
                        </Col>
                    </Row>
                    <hr/>
                    <Row id={'socmint'}>
                        <Col md={6} className={'add-space-on-mobile'}>
                            <Advantages.ContentBlock>
                                <h2>Holistic Social Media Intelligence (SOCMINT)</h2>
                                <p>
                                    Darkivore monitors 20+ social and messaging platforms to uncover scams,
                                    impersonations,
                                    and
                                    data leaks in real time. From fake profiles, pages, posts and groups on Facebook,
                                    Instagram,
                                    TikTok, and X (formerly Twitter) to impersonation of VIPs and executives, it detects
                                    threats
                                    across public and private spaces, including Telegram, Discord, WhatsApp, and IRC
                                    channels.
                                    Whether it’s exposed emails, leaked personal data, or coordinated hacking groups,
                                    Darkivore
                                    brings visibility to the social layer of digital risk.
                                </p>
                            </Advantages.ContentBlock>
                        </Col>
                        <Col md={6}>
                            <img alt="" src={ImgSocialMedia} className={'img-fluid'}/>
                        </Col>
                    </Row>
                    <hr/>
                    <Row id={'takedowns'}>
                        <Advantages.ContentBlock className={'mb-5'}>
                            <h2>Hyper-Fast, Unlimited Takedowns</h2>
                            <p>
                                Darkivore acts fast, removing threats in as little as 20 minutes, with unlimited
                                takedown
                                capacity. From phishing sites and rogue apps to fake social media profiles and leaked
                                source
                                code, it handles takedowns across all risk levels:<br/><br/>
                                <ul>
                                    <li>High/Critical: Phishing sites, malware, cybersquatting, scam social media pages,
                                        and
                                        rogue
                                        apps.
                                    </li>
                                    <li>Medium: Trademark abuse, impersonation, leaked documents, and mirrored phishing
                                        forms.
                                    </li>
                                    <li>Low: Dormant threat actors or inactive malicious content.</li>
                                </ul>
                            </p>
                        </Advantages.ContentBlock>
                        <Col md={6} className={'add-space-on-mobile'}>
                            <img alt="" src={ImgTakedownHighRisks} alt="" className={'img-fluid'}/>
                        </Col>
                        <Col md={6}>
                            <img alt="" src={ImgTakedownFB} alt="" className={'img-fluid'}/>
                        </Col>
                    </Row>
                </Container>
            </Advantages.Container>
            <FormSection.Container className={'container-fluid'}>
                <FormSection.Card width={"100%"} flexDirection="row" padding="50px">
                    <div>
                        <div className="form-title">
                            Get a Free Demo!
                        </div>
                        <div className="form-comment">
                            Leave your email to get a free demo!
                        </div>
                    </div>
                    <div>
                        <FormRow compact>
                            <FieldRow>
                                <Input
                                    placeholder="Email"
                                    value={email}
                                    onChange={event => {
                                        setEmail(event.target.value?.trim());
                                        setMessageValidation(null);
                                    }}
                                    style={fieldsStyle}
                                    sx={sxProps}/>
                            </FieldRow>
                        </FormRow>
                        <div className="form-error">{messageValidation ?? ''}</div>
                        <div className="form-message">
                            By submitting your email address, you agree to receiving emails from potech and acknowledge
                            our <SpanPolicy style={{fontStyle: 'normal'}} target="_blank" href="/privacy_notice">Privacy
                            Policy</SpanPolicy>.
                        </div>
                        <button className="form-button" onClick={handleSubmit} disabled={isLoading}>
                            REQUEST DEMO
                        </button>
                    </div>
                </FormSection.Card>
            </FormSection.Container>

            <CaptchaDialog
                loading={loading}
                open={captchaOpen}
                setOpen={setCaptchaOpen}
                submitHandler={submitDemo}
                btnText={'SUBMIT'}
                setCaptchaKey={setCaptchaKey}
            />
            <ThanksDialog open={thanksOpen} setOpen={setThanksOpen} title={'Thank You For Your Message!'}/>
        </Wrapper>
    </>
}

export default CTIAndDarkiForce;
